// extracted by mini-css-extract-plugin
export default {"container":"PaymentsChart_container__qX81w","title":"PaymentsChart_title__5lj0b","placeholder":"PaymentsChart_placeholder__lQHe6"};